export default "__VITE_ASSET__BtEdtdsR__"